export default __webpack_public_path__ + "static/media/thumbnail-12.b837808c.jpg";